import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22Bebas_Neue%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22variable%22:%22--font-bebas-neue%22,%22weight%22:[%22400%22],%22display%22:%22swap%22,%22preload%22:false,%22fallback%22:[%22Oswald%22,%22Impact%22,%22sans-serif%22]}],%22variableName%22:%22bebasNeue%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Bebas Neue', Oswald, Impact, sans-serif",
        fontWeight: 400,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
